import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PolicyAction } from '../../store/policy.action';
import { PolicyStateModel } from '../../store/policy.state';

@Injectable()
export class PolicyResolver implements Resolve<any> {

    constructor(private store: Store) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        const id = +route.params.id;
        return this.store.dispatch(new PolicyAction.GetListByOfferId(id))
            .pipe(switchMap(({policy}: { policy: PolicyStateModel }) => {
                if (policy.policies.length === 0) {
                    return throwError(null);
                }
                return of(null);
            }));
    }
}
